import React from 'react';
import useNombreJugador from '../hooks/useNombreJugador';

// Tabla de puntos por jugador y jornada, acumulados hasta la jornada actual.
// Sin columna "Total" cuando solo hay una jornada (sería igual a J1).
const RankingAcumulado = ({ jornadas, filas }) => {
    const nombreDe = useNombreJugador();
    if (filas.length === 0) return null;
    const mostrarTotal = jornadas.length > 1;

    return (
        <div className="ranking-acumulado">
            <table className="ranking-acumulado-tabla">
                <thead>
                    <tr>
                        <th className="ranking-acumulado-jugador">Jugadores</th>
                        {jornadas.map((n) => <th key={n}>J{n}</th>)}
                        {mostrarTotal && <th>Total</th>}
                    </tr>
                </thead>
                <tbody>
                    {filas.map((f) => (
                        <tr key={f.jugadorId}>
                            <td className="ranking-acumulado-jugador">{nombreDe(f)}</td>
                            {f.porJornada.map((p, i) => <td key={jornadas[i]}>{p}</td>)}
                            {mostrarTotal && <td className="ranking-acumulado-total">{f.total}</td>}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RankingAcumulado;
